import { GlobalIcon } from "get-life-storybook-ts";

interface FormLabelProps {
  num: string;
  title: string;
  active?: boolean;
  done?: boolean;
}

const FormLabel = ({ num, title, active = false, done = false }: FormLabelProps) => {
  const numMod = done
    ? "paymentV3FormLabel__num--done"
    : active
      ? "paymentV3FormLabel__num--active"
      : "";
  const titleMod = done
    ? "paymentV3FormLabel__title--done"
    : active
      ? "paymentV3FormLabel__title--active"
      : "";

  return (
    <div className="paymentV3FormLabel">
      <span className={`paymentV3FormLabel__num ${numMod}`}>
        {done ? (
          <GlobalIcon iconName="CheckedIcon" size="XS" color="#FFFFFF" />
        ) : (
          num
        )}
      </span>
      <h3 className={`paymentV3FormLabel__title ${titleMod}`}>{title}</h3>
    </div>
  );
};

export default FormLabel;
